import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {DownloadButton} from '@dized/ui';

const DownloadContainer = styled.div`
  margin: 16px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
`;

const DownloadTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #495057;
`;

const DownloadDescription = styled.p`
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #6c757d;
  line-height: 1.4;
`;

const StyledDownloadButton = styled(DownloadButton)`
  margin: 0;
`;

/**
 * TranslationDownload - Standalone component for downloading translation files
 * Extracted from LocaleTable to be reusable across different parts of the application
 * @param {Object} props - Component props
 * @returns {React.Component|null} The TranslationDownload component or null if disabled
 */
export const TranslationDownload = ({
  title,
  description,
  generateFile,
  filename,
  buttonText,
  disabled,
}) => {
  if (!generateFile || !filename || disabled) {
    return null;
  }

  return (
    <DownloadContainer>
      <DownloadTitle>{title}</DownloadTitle>
      {description && <DownloadDescription>{description}</DownloadDescription>}
      <StyledDownloadButton
        generateFile={generateFile}
        initialValue={filename}
      >
        {buttonText}
      </StyledDownloadButton>
    </DownloadContainer>
  );
};

TranslationDownload.propTypes = {
  /** Title for the download section */
  title: PropTypes.string.isRequired,
  /** Optional description text */
  description: PropTypes.string,
  /** Function that generates the file to download */
  generateFile: PropTypes.func.isRequired,
  /** Default filename for the download */
  filename: PropTypes.string.isRequired,
  /** Text to display on the download button */
  buttonText: PropTypes.string,
  /** Whether the download should be disabled */
  disabled: PropTypes.bool,
};

TranslationDownload.defaultProps = {
  buttonText: 'Download',
  disabled: false,
};

export default TranslationDownload;
